import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import style from '../ProductPrice.module.scss.js';

const PriceNote = ({ children, text, isSuffix, ...otherProps }) => text || children ? (jsx("div", { className: classNames(style['z-product-price__note'], {
        [style['z-product-price__note--suffix']]: isSuffix,
    }), ...otherProps, children: children || text })) : null;
PriceNote.displayName = 'PriceNote';

export { PriceNote };
//# sourceMappingURL=PriceNote.js.map
